import { render, staticRenderFns } from "./HrFormReport.vue?vue&type=template&id=61778efa&scoped=true"
import script from "./HrFormReport.vue?vue&type=script&lang=js"
export * from "./HrFormReport.vue?vue&type=script&lang=js"
import style0 from "./HrFormReport.vue?vue&type=style&index=0&id=61778efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61778efa",
  null
  
)

export default component.exports